import { KEYBOARD_MODE_CSS_VAR } from 'constants/app'
import { css } from 'styled-components'

const interactiveFocusStyle = css`
  outline: var(${KEYBOARD_MODE_CSS_VAR}, 2px solid ${props => props.theme.palette.neutral.default.five});
  outline-offset: var(${KEYBOARD_MODE_CSS_VAR}, 2px);
`

export default interactiveFocusStyle
